import React, { forwardRef } from "react";
import { allStyles } from "style-guide/styles/Text";
import clsx from "clsx";

interface TypographyProps extends Omit<React.HTMLAttributes<HTMLParagraphElement>, 'className'> {
  variant: string;
  strong?: boolean;
  underline?: boolean;
  italic?: boolean;
  delete?: boolean;
  className?: string;
  text?: string;
  children?: React.ReactNode;
}

const Typography = forwardRef<HTMLParagraphElement, TypographyProps>(
  (
    {
      text,
      children,
      variant,
      strong,
      underline,
      italic,
      className,
      delete: del,
      style: propStyle,
      ...restProps
    },
    ref
  ) => {
    const styleObject = allStyles.find((style) => style.name === variant);

    const style: React.CSSProperties = {
      fontFamily: "",
      fontSize: styleObject?.fontSize,
      lineHeight: styleObject?.lineHeight,
      fontWeight: strong ? "bold" : "normal",
      textDecoration: underline ? "underline" : del ? "line-through" : "none",
      fontStyle: italic ? "italic" : "normal",
      whiteSpace: "pre-wrap",
      ...propStyle,
    };

    return (
      <p
        ref={ref}
        style={style}
        className={clsx(className)}
        {...restProps}
      >
        {children || text}
      </p>
    );
  }
);

Typography.displayName = "Typography";

export default Typography;
